import React from 'react';
import { faqs } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  return (
    <section className="section-spacing bg-white">
      <div className="container-main">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Header */}
          <div>
            <span className="caption mb-3 block">Dúvidas frequentes</span>
            <h2 className="heading-1 mb-4">Perguntas Frequentes</h2>
            <p className="body-medium">
              Esclarecemos as principais dúvidas sobre nossos serviços. 
              Se não encontrar sua resposta, entre em contato.
            </p>
          </div>

          {/* FAQ Accordion */}
          <div>
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq) => (
                <AccordionItem 
                  key={faq.id} 
                  value={`item-${faq.id}`}
                  className="border-b border-[#E2E8F0]"
                >
                  <AccordionTrigger className="text-left text-[#0F172A] font-medium hover:text-[#3E6B2A] transition-colors py-4 text-sm">
                    <span className="pr-4">{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="text-[#64748B] text-sm leading-relaxed pb-4">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
